export default __webpack_public_path__ + "static/media/gallery-articles_01.f29591df.jpg";